import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const collectUserData = ({ccStateId, ccSourceStateId, userCreatedStateId, templateIds, listing, mockData, next}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("company"),
    consumeContext("templateOptions"),
    ({session, company, templateOptions}) => {
        let mockDataFormatted;
        if(!mockData?.loading && !mockDataFormatted){
            mockDataFormatted = {};
            mockData?.value.forEach((data)=>{
                mockDataFormatted[data.name] = data.value ? JSON.parse( data.value ) : {}
            });
        }
        return next(
            !session.loading && company && ((session.data.branch && session.data.region && session.data.messages) || !mockData?.loading) && {
                "templateIds": templateIds,
                ccStateId,
                userCreatedStateId,
                ccSourceStateId,
                sourceData: {
                    xd: {
                        "user": {...session.data.agent},
                        "office": session.data.branch?.branchLinkId != 'guestOffice' ? session.data.branch : {
                            ...session.data.branch,
                            "branchDisplayCustom1": "",
                            "branchDisplayCustom2": "",
                            "branchDisplay1": "",
                            "branchDisplay2": "",
                            "branchDisplay3": "",
                            "branchDisplay4": "",
                            "branchDisplay5": "",
                            "branchDisplay6": ""
                        },
                        region: session.data.region,
                        company: {...company, imageGallery: {...company.imageGallery, ...templateOptions?.imageGallery}},
                        listing: {...listing},
                        messages: session.data.messages,
                        templateOptions,
                        ...mockDataFormatted
                    },
                },
            }
        )
    }
);
